/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeStyleSettingsDTO } from './AttributeStyleSettingsDTO';
import {
    AttributeStyleSettingsDTOFromJSON,
    AttributeStyleSettingsDTOFromJSONTyped,
    AttributeStyleSettingsDTOToJSON,
} from './AttributeStyleSettingsDTO';

/**
 * 
 * @export
 * @interface AttributesStyleSettingsResultDTO
 */
export interface AttributesStyleSettingsResultDTO {
    /**
     * 
     * @type {Array<AttributeStyleSettingsDTO>}
     * @memberof AttributesStyleSettingsResultDTO
     */
    settings?: Array<AttributeStyleSettingsDTO>;
}

/**
 * Check if a given object implements the AttributesStyleSettingsResultDTO interface.
 */
export function instanceOfAttributesStyleSettingsResultDTO(value: object): value is AttributesStyleSettingsResultDTO {
    return true;
}

export function AttributesStyleSettingsResultDTOFromJSON(json: any): AttributesStyleSettingsResultDTO {
    return AttributesStyleSettingsResultDTOFromJSONTyped(json, false);
}

export function AttributesStyleSettingsResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributesStyleSettingsResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'settings': json['settings'] == null ? undefined : ((json['settings'] as Array<any>).map(AttributeStyleSettingsDTOFromJSON)),
    };
}

export function AttributesStyleSettingsResultDTOToJSON(value?: AttributesStyleSettingsResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'settings': value['settings'] == null ? undefined : ((value['settings'] as Array<any>).map(AttributeStyleSettingsDTOToJSON)),
    };
}

